import APPCONFIG from '../../constants/Config';
import * as types from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.loading;
const loading = (state = initialSettings, action) => {
  switch (action.type) {
    // Fore hide management
    case types.HIDE_LOADING:
      return {
        ...state,
        forceHide: true,
        operation: false,
        processing: false,
      };
    case types.HIDE_LOADING_REINIT:
      return {
        ...state,
        forceHide: false,
      };

    // === Loading activation === //
    case types.START_LOADING:
    case types.GET_ME:
    case types.UPDATE_ME:
    case types.SEND_CMD_DEVICE:
    case types.SEND_DEVICE_SMS:
    case types.GET_DEVICE_SMS_STATUS:
    case types.DELETE_DEVICE:
    case types.UPDATE_DEVICE:
    case types.UPDATE_DEVICE_CONFIG:
    case types.LINK_DEVICE_SIMCARD:
    case types.UNLINK_DEVICE_SIMCARD:
    case types.DELETE_DEVICE_SLAVE:
    case types.UPDATE_DEVICE_SLAVE:
    case types.ADD_INSTALLATION:
    case types.UPDATE_INSTALLATION:
    case types.DELETE_INSTALLATION:
    case types.ADD_INSTALLATION_ENTITY:
    case types.UPDATE_INSTALLATION_ENTITY:
    case types.DELETE_INSTALLATION_ENTITY:
    case types.ADD_INSTALLATION_DOOR:
    case types.UPDATE_INSTALLATION_DOOR:
    case types.DELETE_INSTALLATION_DOOR:
    case types.ADD_INSTALLATION_SOURCE:
    case types.UPDATE_INSTALLATION_SOURCE:
    case types.DELETE_INSTALLATION_SOURCE:
    case types.ADD_INSTALLATION_DEVICE:
    case types.UPDATE_INSTALLATION_DEVICE:
    case types.DELETE_INSTALLATION_DEVICE:
    case types.REPLACE_INSTALLATION_DEVICE:
    case types.ADD_INSTALLATION_DEVICE_SLAVE:
    case types.UPDATE_INSTALLATION_DEVICE_SLAVE:
    case types.DELETE_INSTALLATION_DEVICE_SLAVE:
    case types.REPLACE_INSTALLATION_DEVICE_SLAVE:
    case types.ADD_INSTALLATION_SCENARIO:
    case types.UPDATE_INSTALLATION_SCENARIO:
    case types.DELETE_INSTALLATION_SCENARIO:
    case types.TRIGGER_INSTALLATION_SCENARIO:
    case types.ADD_INSTALLATION_CUSTOMER:
    case types.UPDATE_INSTALLATION_CUSTOMER:
    case types.UPDATE_INSTALLATION_CUSTOMER_STATE:
    case types.DELETE_INSTALLATION_CUSTOMER:
    case types.GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES:
    case types.EXPORT_INSTALLATION_CUSTOMERS:
    case types.ADD_INSTALLATION_CUSTOMER_ACCESSWAY:
    case types.UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY:
    case types.DELETE_INSTALLATION_CUSTOMER_ACCESSWAY:
    case types.TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT:
    case types.ADD_INSTALLATION_PLANNING:
    case types.UPDATE_INSTALLATION_PLANNING:
    case types.DELETE_INSTALLATION_PLANNING:
    case types.ADD_SIMCARDS:
    case types.UPDATE_SIMCARD:
    case types.SYNCHRONIZE_SIMCARDS:
    case types.ACTIVATE_SIMCARDS:
    case types.ADD_SIMCARD_GROUP:
    case types.LINK_SIMCARD_DEVICE:
    case types.UNLINK_SIMCARD_DEVICE:
    case types.ADD_SIMCARD_GROUP_APN:
    case types.DELETE_SIMCARD_GROUP_APN:
    case types.ADD_COMPANY:
    case types.UPDATE_COMPANY:
    case types.DELETE_COMPANY:
    case types.ADD_USER:
    case types.UPDATE_USER:
    case types.DELETE_USER:
    case types.ADD_PROFILE:
    case types.UPDATE_PROFILE:
    case types.DELETE_PROFILE:
    case types.ADD_DEVICE_BATCH:
    case types.GET_DEVICE_BATCH_ARCHIVE:
    case types.UPDATE_DISTRIBUTION:
    case types.DELETE_DISTRIBUTION:
    case types.GET_DISTRIBUTION_ARCHIVE:
    case types.ADD_ROLLOUT:
    case types.DELETE_ROLLOUT:
    case types.CPM_GET_CARPARK_DEFAULT_SLUG:
    case types.CPM_GET_CARPARK_SYNCHRONIZATION_STATUSES:
    case types.CPM_UPDATE_CARPARK:
    case types.CPM_UPDATE_CARPARK_CONTACT:
    case types.CPM_UPDATE_CARPARK_ON_DEMAND_ACCESS_STATE:
    case types.CPM_TRIGGER_CARPARK_DOOR:
    case types.CPM_UPDATE_CARPARK_BOOKING_SETTINGS:
    case types.CPM_UPDATE_CARPARK_GENERAL_SETTINGS:
    case types.CPM_UPDATE_CARPARK_ON_DEMAND_SETTINGS:
    case types.CPM_UPDATE_CARPARK_LICENSE_PLATE_SETTINGS:
    case types.CPM_UPDATE_CARPARK_SPACES_SETTINGS:
    case types.CPM_UPDATE_CARPARK_FINANCIAL_INFORMATION:
    case types.CPM_UPDATE_CARPARK_PARTNER:
    case types.CPM_ADD_CARPARK_PLANNING:
    case types.CPM_UPDATE_CARPARK_PLANNING:
    case types.CPM_DELETE_CARPARK_PLANNING:
    case types.CPM_ADD_CARPARK_PARKING_CATEGORY:
    case types.CPM_UPDATE_CARPARK_PARKING_CATEGORY:
    case types.CPM_DELETE_CARPARK_PARKING_CATEGORY:
    case types.CPM_ADD_CARPARK_PRICE_GRID_TO_PARKING_CATEGORY:
    case types.CPM_DELETE_CARPARK_PRICE_GRID_FROM_PARKING_CATEGORY:
    case types.CPM_SEND_CARPARK_PRICE_GRID_TO_CUSTOMER:
    case types.CPM_ADD_CARPARK_PRICE_GRID:
    case types.CPM_UPDATE_CARPARK_PRICE_GRID:
    case types.CPM_GET_CARPARK_CUSTOMER:
    case types.CPM_ADD_CARPARK_CUSTOMER:
    case types.CPM_UPDATE_CARPARK_CUSTOMER:
    case types.CPM_DELETE_CARPARK_CUSTOMER:
    case types.CPM_CREATE_CARPARK_CUSTOMER_ACCOUNT:
    case types.CPM_DELETE_CARPARK_CUSTOMER_ACCOUNT:
    case types.CPM_ADD_CARPARK_PARKING:
    case types.CPM_ADD_CARPARK_BOOKING:
    case types.CPM_UPDATE_CARPARK_PARKING:
    case types.CPM_UPDATE_CARPARK_PARKING_STATE:
    case types.CPM_UPDATE_CARPARK_BOOKING:
    case types.CPM_UPDATE_CARPARK_BOOKING_STATE:
    case types.CPM_VALIDATE_CUSTOMER_ACCOUNT_LINK:
    case types.CPM_VALIDATE_ACCOUNT_LINK:
    case types.CPM_CANCEL_CARPARK_BOOKING:
    case types.CPM_SEND_BOOKING_PAYMENT_LINK:
    case types.CPM_REFUND_BOOKING:
    case types.CPM_REFUND_ON_DEMAND_ACCESS:
    case types.CPM_REFUND_PURCHASE:
    case types.CPM_DELETE_CARPARK_PARKING:
    case types.CPM_CATEGORIZE_CARPARK_ON_DEMAND:
    case types.CPM_DELETE_CARPARK_ON_DEMAND:
    case types.CPM_BOOK_CARPARK:
    case types.CPM_EXTEND_BOOK_CARPARK:
    case types.CPM_PAY_BOOKING_OVERSTAY:
    case types.CPM_SEARCH_CARPARK_BOOKING_EXTENSION_OFFER:
    case types.CPM_CANCEL_MY_BOOKING:
    case types.CPM_SET_ACCOUNT_STATUS:
    case types.CPM_SEARCH_ON_DEMAND_ACCESS:
    case types.CPM_GET_ON_DEMAND_ACCESS:
    case types.CPM_SELF_CHECKOUT_ON_DEMAND_ACCESS:
    case types.CPM_EXTEND_ON_DEMAND_ACCESS:
    case types.CPM_PAY_ON_DEMAND_ACCESS_OVERSTAY:
    case types.CPM_CREATE_PARTNER:
    case types.CPM_UPDATE_PARTNER_FINANCIAL_INFORMATION:
    case types.CPM_DOWNLOAD_CARPARK_INVOICE:
    case types.CPM_DOWNLOAD_CARPARK_INVOICES:
    case types.CPM_DOWNLOAD_MY_INVOICE:
    case types.CPM_UPDATE_CARPARK_INVOICE:
    case types.CPM_RESEND_BOOKING_CONFIRMATION_EMAIL:
    case types.CPM_CREATE_ON_DEMAND_ACCESS:
    case types.CPM_TERMINATE_ON_DEMAND_ACCESS:
    case types.CPM_UPDATE_ON_DEMAND_ACCESS_CUSTOMER:
    case types.CPM_UPDATE_ON_DEMAND_ACCESS:
    case types.CPM_DECLARE_FINAL_EXIT_FOR_TEMPORARY_ON_DEMAND_ACCESS:
    case types.CPM_DECLARE_FINAL_EXIT_FOR_BOOKING:
    case types.CPM_CREATE_WORKSPACE:
    case types.CPM_CREATE_WORKSPACE_GROUP:
    case types.CPM_UPDATE_WORKSPACE:
    case types.CPM_UPDATE_WORKSPACE_GROUP:
    case types.CPM_INITIATE_PAYMENT:
    case types.CPM_DELETE_MY_PAYMENT_METHOD:
    case types.CPM_UPDATE_CARPARK_WORKSPACE_GROUPS:
    case types.CPM_CREATE_SLUG:
    case types.CPM_DELETE_SLUG:
    case types.CPM_UPDATE_SLUG:
    case types.CPM_SIGN_UP:
    case types.CPM_CREATE_SERVICE_FEE_RULE:
    case types.CPM_DELETE_SERVICE_FEE_RULE:
    case types.CPM_UPDATE_SERVICE_FEE_RULE:
      return {
        ...state,
        operation: true,
        processing: false,
      };

    case types.ADD_DISTRIBUTION:
      return {
        ...state,
        operation: true,
        processing: true,
      };

    // === Loading deactivation === //
    case types.GET_INSTALLATION_ERROR:
    case types.GET_DEVICE_ERROR:
    case types.GET_SIMCARD_ERROR:
    case types.GET_COMPANY_ERROR:
    case types.GET_USER_ERROR:
    case types.GET_PROFILE_ERROR:
    case types.GET_DEVICE_BATCH_ERROR:
    case types.END_LOADING:
    case `${types.GET_ME}_SUCCESS`:
    case `${types.GET_ME}_ERROR`:
    case `${types.UPDATE_ME}_SUCCESS`:
    case `${types.UPDATE_ME}_ERROR`:
    case types.SEND_CMD_DEVICE_SUCCESS:
    case types.SEND_CMD_DEVICE_ERROR:
    case types.SEND_DEVICE_SMS_SUCCESS:
    case types.SEND_DEVICE_SMS_ERROR:
    case types.GET_DEVICE_SMS_STATUS_SUCCESS:
    case types.GET_DEVICE_SMS_STATUS_ERROR:
    case types.DELETE_DEVICE_SUCCESS:
    case types.DELETE_DEVICE_ERROR:
    case types.UPDATE_DEVICE_SUCCESS:
    case types.UPDATE_DEVICE_ERROR:
    case types.UPDATE_DEVICE_CONFIG_SUCCESS:
    case types.UPDATE_DEVICE_CONFIG_ERROR:
    case types.LINK_DEVICE_SIMCARD_SUCCESS:
    case types.LINK_DEVICE_SIMCARD_ERROR:
    case types.UNLINK_DEVICE_SIMCARD_SUCCESS:
    case types.UNLINK_DEVICE_SIMCARD_ERROR:
    case types.DELETE_DEVICE_SLAVE_SUCCESS:
    case types.DELETE_DEVICE_SLAVE_ERROR:
    case types.UPDATE_DEVICE_SLAVE_SUCCESS:
    case types.UPDATE_DEVICE_SLAVE_ERROR:
    case types.ADD_INSTALLATION_SUCCESS:
    case types.ADD_INSTALLATION_ERROR:
    case types.UPDATE_INSTALLATION_SUCCESS:
    case types.UPDATE_INSTALLATION_ERROR:
    case types.DELETE_INSTALLATION_SUCCESS:
    case types.DELETE_INSTALLATION_ERROR:
    case types.ADD_INSTALLATION_ENTITY_SUCCESS:
    case types.ADD_INSTALLATION_ENTITY_ERROR:
    case types.UPDATE_INSTALLATION_ENTITY_SUCCESS:
    case types.UPDATE_INSTALLATION_ENTITY_ERROR:
    case types.DELETE_INSTALLATION_ENTITY_SUCCESS:
    case types.DELETE_INSTALLATION_ENTITY_ERROR:
    case types.ADD_INSTALLATION_DOOR_SUCCESS:
    case types.ADD_INSTALLATION_DOOR_ERROR:
    case types.UPDATE_INSTALLATION_DOOR_SUCCESS:
    case types.UPDATE_INSTALLATION_DOOR_ERROR:
    case types.DELETE_INSTALLATION_DOOR_SUCCESS:
    case types.DELETE_INSTALLATION_DOOR_ERROR:
    case types.ADD_INSTALLATION_SOURCE_SUCCESS:
    case types.ADD_INSTALLATION_SOURCE_ERROR:
    case types.UPDATE_INSTALLATION_SOURCE_SUCCESS:
    case types.UPDATE_INSTALLATION_SOURCE_ERROR:
    case types.DELETE_INSTALLATION_SOURCE_SUCCESS:
    case types.DELETE_INSTALLATION_SOURCE_ERROR:
    case types.ADD_INSTALLATION_DEVICE_SUCCESS:
    case types.ADD_INSTALLATION_DEVICE_ERROR:
    case types.UPDATE_INSTALLATION_DEVICE_SUCCESS:
    case types.UPDATE_INSTALLATION_DEVICE_ERROR:
    case types.DELETE_INSTALLATION_DEVICE_SUCCESS:
    case types.DELETE_INSTALLATION_DEVICE_ERROR:
    case types.REPLACE_INSTALLATION_DEVICE_SUCCESS:
    case types.REPLACE_INSTALLATION_DEVICE_ERROR:
    case types.ADD_INSTALLATION_DEVICE_SLAVE_SUCCESS:
    case types.ADD_INSTALLATION_DEVICE_SLAVE_ERROR:
    case types.UPDATE_INSTALLATION_DEVICE_SLAVE_SUCCESS:
    case types.UPDATE_INSTALLATION_DEVICE_SLAVE_ERROR:
    case types.DELETE_INSTALLATION_DEVICE_SLAVE_SUCCESS:
    case types.DELETE_INSTALLATION_DEVICE_SLAVE_ERROR:
    case types.REPLACE_INSTALLATION_DEVICE_SLAVE_SUCCESS:
    case types.REPLACE_INSTALLATION_DEVICE_SLAVE_ERROR:
    case types.ADD_INSTALLATION_SCENARIO_SUCCESS:
    case types.ADD_INSTALLATION_SCENARIO_ERROR:
    case types.UPDATE_INSTALLATION_SCENARIO_SUCCESS:
    case types.UPDATE_INSTALLATION_SCENARIO_ERROR:
    case types.DELETE_INSTALLATION_SCENARIO_SUCCESS:
    case types.DELETE_INSTALLATION_SCENARIO_ERROR:
    case types.TRIGGER_INSTALLATION_SCENARIO_SUCCESS:
    case types.TRIGGER_INSTALLATION_SCENARIO_ERROR:
    case types.ADD_INSTALLATION_CUSTOMER_SUCCESS:
    case types.ADD_INSTALLATION_CUSTOMER_ERROR:
    case types.UPDATE_INSTALLATION_CUSTOMER_SUCCESS:
    case types.UPDATE_INSTALLATION_CUSTOMER_ERROR:
    case types.UPDATE_INSTALLATION_CUSTOMER_STATE_SUCCESS:
    case types.UPDATE_INSTALLATION_CUSTOMER_STATE_ERROR:
    case types.DELETE_INSTALLATION_CUSTOMER_SUCCESS:
    case types.DELETE_INSTALLATION_CUSTOMER_ERROR:
    case types.GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES_SUCCESS:
    case types.GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES_ERROR:
    case types.EXPORT_INSTALLATION_CUSTOMERS_SUCCESS:
    case types.EXPORT_INSTALLATION_CUSTOMERS_ERROR:
    case types.ADD_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS:
    case types.ADD_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR:
    case types.UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS:
    case types.UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR:
    case types.DELETE_INSTALLATION_CUSTOMER_ACCESSWAY_SUCCESS:
    case types.DELETE_INSTALLATION_CUSTOMER_ACCESSWAY_ERROR:
    case types.TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_SUCCESS:
    case types.TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT_ERROR:
    case types.ADD_INSTALLATION_PLANNING_SUCCESS:
    case types.ADD_INSTALLATION_PLANNING_ERROR:
    case types.UPDATE_INSTALLATION_PLANNING_SUCCESS:
    case types.UPDATE_INSTALLATION_PLANNING_ERROR:
    case types.DELETE_INSTALLATION_PLANNING_SUCCESS:
    case types.DELETE_INSTALLATION_PLANNING_ERROR:
    case types.ADD_SIMCARDS_SUCCESS:
    case types.ADD_SIMCARDS_ERROR:
    case types.UPDATE_SIMCARD_SUCCESS:
    case types.UPDATE_SIMCARD_ERROR:
    case types.SYNCHRONIZE_SIMCARDS_SUCCESS:
    case types.SYNCHRONIZE_SIMCARDS_ERROR:
    case types.ACTIVATE_SIMCARDS_SUCCESS:
    case types.ACTIVATE_SIMCARDS_ERROR:
    case types.LINK_SIMCARD_DEVICE_SUCCESS:
    case types.LINK_SIMCARD_DEVICE_ERROR:
    case types.UNLINK_SIMCARD_DEVICE_SUCCESS:
    case types.UNLINK_SIMCARD_DEVICE_ERROR:
    case types.ADD_SIMCARD_GROUP_SUCCESS:
    case types.ADD_SIMCARD_GROUP_ERROR:
    case types.ADD_SIMCARD_GROUP_APN_SUCCESS:
    case types.ADD_SIMCARD_GROUP_APN_ERROR:
    case types.DELETE_SIMCARD_GROUP_APN_SUCCESS:
    case types.DELETE_SIMCARD_GROUP_APN_ERROR:
    case types.ADD_COMPANY_SUCCESS:
    case types.ADD_COMPANY_ERROR:
    case types.UPDATE_COMPANY_SUCCESS:
    case types.UPDATE_COMPANY_ERROR:
    case types.DELETE_COMPANY_SUCCESS:
    case types.DELETE_COMPANY_ERROR:
    case types.ADD_USER_SUCCESS:
    case types.ADD_USER_ERROR:
    case types.UPDATE_USER_SUCCESS:
    case types.UPDATE_USER_ERROR:
    case types.DELETE_USER_SUCCESS:
    case types.DELETE_USER_ERROR:
    case types.ADD_PROFILE_SUCCESS:
    case types.ADD_PROFILE_ERROR:
    case types.UPDATE_PROFILE_SUCCESS:
    case types.UPDATE_PROFILE_ERROR:
    case types.DELETE_PROFILE_SUCCESS:
    case types.DELETE_PROFILE_ERROR:
    case types.ADD_DEVICE_BATCH_SUCCESS:
    case types.ADD_DEVICE_BATCH_ERROR:
    case types.GET_DEVICE_BATCH_ARCHIVE_SUCCESS:
    case types.GET_DEVICE_BATCH_ARCHIVE_ERROR:
    case types.ADD_DISTRIBUTION_SUCCESS:
    case types.ADD_DISTRIBUTION_ERROR:
    case types.UPDATE_DISTRIBUTION_SUCCESS:
    case types.UPDATE_DISTRIBUTION_ERROR:
    case types.DELETE_DISTRIBUTION_SUCCESS:
    case types.DELETE_DISTRIBUTION_ERROR:
    case types.GET_DISTRIBUTION_ARCHIVE_SUCCESS:
    case types.GET_DISTRIBUTION_ARCHIVE_ERROR:
    case types.ADD_ROLLOUT_SUCCESS:
    case types.ADD_ROLLOUT_ERROR:
    case types.DELETE_ROLLOUT_SUCCESS:
    case types.DELETE_ROLLOUT_ERROR:
    case `${types.CPM_GET_CARPARK_DEFAULT_SLUG}_SUCCESS`:
    case `${types.CPM_GET_CARPARK_DEFAULT_SLUG}_ERROR`:
    case `${types.CPM_GET_CARPARK_SYNCHRONIZATION_STATUSES}_SUCCESS`:
    case `${types.CPM_GET_CARPARK_SYNCHRONIZATION_STATUSES}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_CONTACT}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_CONTACT}_ERROR`:
    case `${types.CPM_TRIGGER_CARPARK_DOOR}_SUCCESS`:
    case `${types.CPM_TRIGGER_CARPARK_DOOR}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_BOOKING_SETTINGS}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_BOOKING_SETTINGS}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_GENERAL_SETTINGS}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_GENERAL_SETTINGS}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_ON_DEMAND_SETTINGS}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_ON_DEMAND_SETTINGS}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_LICENSE_PLATE_SETTINGS}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_LICENSE_PLATE_SETTINGS}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_SPACES_SETTINGS}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_SPACES_SETTINGS}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_FINANCIAL_INFORMATION}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_FINANCIAL_INFORMATION}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_PARTNER}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_PARTNER}_ERROR`:
    case `${types.CPM_ADD_CARPARK_PLANNING}_SUCCESS`:
    case `${types.CPM_ADD_CARPARK_PLANNING}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_PLANNING}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_PLANNING}_ERROR`:
    case `${types.CPM_DELETE_CARPARK_PLANNING}_SUCCESS`:
    case `${types.CPM_DELETE_CARPARK_PLANNING}_ERROR`:
    case `${types.CPM_ADD_CARPARK_PARKING_CATEGORY}_SUCCESS`:
    case `${types.CPM_ADD_CARPARK_PARKING_CATEGORY}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_PARKING_CATEGORY}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_PARKING_CATEGORY}_ERROR`:
    case `${types.CPM_DELETE_CARPARK_PARKING_CATEGORY}_SUCCESS`:
    case `${types.CPM_DELETE_CARPARK_PARKING_CATEGORY}_ERROR`:
    case `${types.CPM_ADD_CARPARK_PRICE_GRID_TO_PARKING_CATEGORY}_SUCCESS`:
    case `${types.CPM_ADD_CARPARK_PRICE_GRID_TO_PARKING_CATEGORY}_ERROR`:
    case `${types.CPM_DELETE_CARPARK_PRICE_GRID_FROM_PARKING_CATEGORY}_SUCCESS`:
    case `${types.CPM_DELETE_CARPARK_PRICE_GRID_FROM_PARKING_CATEGORY}_ERROR`:
    case `${types.CPM_SEND_CARPARK_PRICE_GRID_TO_CUSTOMER}_SUCCESS`:
    case `${types.CPM_SEND_CARPARK_PRICE_GRID_TO_CUSTOMER}_ERROR`:
    case `${types.CPM_ADD_CARPARK_PRICE_GRID}_SUCCESS`:
    case `${types.CPM_ADD_CARPARK_PRICE_GRID}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_PRICE_GRID}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_PRICE_GRID}_ERROR`:
    case `${types.CPM_GET_CARPARK_CUSTOMER}_SUCCESS`:
    case `${types.CPM_GET_CARPARK_CUSTOMER}_ERROR`:
    case `${types.CPM_ADD_CARPARK_CUSTOMER}_SUCCESS`:
    case `${types.CPM_ADD_CARPARK_CUSTOMER}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_CUSTOMER}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_CUSTOMER}_ERROR`:
    case `${types.CPM_DELETE_CARPARK_CUSTOMER}_SUCCESS`:
    case `${types.CPM_DELETE_CARPARK_CUSTOMER}_ERROR`:
    case `${types.CPM_CREATE_CARPARK_CUSTOMER_ACCOUNT}_SUCCESS`:
    case `${types.CPM_CREATE_CARPARK_CUSTOMER_ACCOUNT}_ERROR`:
    case `${types.CPM_DELETE_CARPARK_CUSTOMER_ACCOUNT}_SUCCESS`:
    case `${types.CPM_DELETE_CARPARK_CUSTOMER_ACCOUNT}_ERROR`:
    case `${types.CPM_ADD_CARPARK_PARKING}_SUCCESS`:
    case `${types.CPM_ADD_CARPARK_PARKING}_ERROR`:
    case `${types.CPM_ADD_CARPARK_BOOKING}_SUCCESS`:
    case `${types.CPM_ADD_CARPARK_BOOKING}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_BOOKING}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_BOOKING}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_ON_DEMAND_ACCESS_STATE}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_ON_DEMAND_ACCESS_STATE}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_BOOKING_STATE}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_BOOKING_STATE}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_PARKING}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_PARKING}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_PARKING_STATE}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_PARKING_STATE}_ERROR`:
    case `${types.CPM_VALIDATE_CUSTOMER_ACCOUNT_LINK}_SUCCESS`:
    case `${types.CPM_VALIDATE_CUSTOMER_ACCOUNT_LINK}_ERROR`:
    case `${types.CPM_VALIDATE_ACCOUNT_LINK}_SUCCESS`:
    case `${types.CPM_VALIDATE_ACCOUNT_LINK}_ERROR`:
    case `${types.CPM_CANCEL_CARPARK_BOOKING}_SUCCESS`:
    case `${types.CPM_CANCEL_CARPARK_BOOKING}_ERROR`:
    case `${types.CPM_SEND_BOOKING_PAYMENT_LINK}_SUCCESS`:
    case `${types.CPM_REFUND_BOOKING}_SUCCESS`:
    case `${types.CPM_REFUND_ON_DEMAND_ACCESS}_SUCCESS`:
    case `${types.CPM_REFUND_PURCHASE}_SUCCESS`:
    case `${types.CPM_SEND_BOOKING_PAYMENT_LINK}_ERROR`:
    case `${types.CPM_REFUND_BOOKING}_ERROR`:
    case `${types.CPM_REFUND_ON_DEMAND_ACCESS}_ERROR`:
    case `${types.CPM_REFUND_PURCHASE}_ERROR`:
    case `${types.CPM_DELETE_CARPARK_PARKING}_SUCCESS`:
    case `${types.CPM_DELETE_CARPARK_PARKING}_ERROR`:
    case `${types.CPM_CATEGORIZE_CARPARK_ON_DEMAND}_SUCCESS`:
    case `${types.CPM_CATEGORIZE_CARPARK_ON_DEMAND}_ERROR`:
    case `${types.CPM_DELETE_CARPARK_ON_DEMAND}_SUCCESS`:
    case `${types.CPM_DELETE_CARPARK_ON_DEMAND}_ERROR`:
    case `${types.CPM_BOOK_CARPARK}_SUCCESS`:
    case `${types.CPM_BOOK_CARPARK}_ERROR`:
    case `${types.CPM_EXTEND_BOOK_CARPARK}_SUCCESS`:
    case `${types.CPM_EXTEND_BOOK_CARPARK}_ERROR`:
    case `${types.CPM_PAY_BOOKING_OVERSTAY}_SUCCESS`:
    case `${types.CPM_PAY_BOOKING_OVERSTAY}_ERROR`:
    case `${types.CPM_SEARCH_CARPARK_BOOKING_EXTENSION_OFFER}_SUCCESS`:
    case `${types.CPM_SEARCH_CARPARK_BOOKING_EXTENSION_OFFER}_ERROR`:
    case `${types.CPM_CANCEL_MY_BOOKING}_SUCCESS`:
    case `${types.CPM_CANCEL_MY_BOOKING}_ERROR`:
    case `${types.CPM_SET_ACCOUNT_STATUS}_SUCCESS`:
    case `${types.CPM_SET_ACCOUNT_STATUS}_ERROR`:
    case `${types.CPM_SEARCH_ON_DEMAND_ACCESS}_SUCCESS`:
    case `${types.CPM_SEARCH_ON_DEMAND_ACCESS}_ERROR`:
    case `${types.CPM_GET_ON_DEMAND_ACCESS}_SUCCESS`:
    case `${types.CPM_GET_ON_DEMAND_ACCESS}_ERROR`:
    case `${types.CPM_SELF_CHECKOUT_ON_DEMAND_ACCESS}_SUCCESS`:
    case `${types.CPM_SELF_CHECKOUT_ON_DEMAND_ACCESS}_ERROR`:
    case `${types.CPM_EXTEND_ON_DEMAND_ACCESS}_SUCCESS`:
    case `${types.CPM_EXTEND_ON_DEMAND_ACCESS}_ERROR`:
    case `${types.CPM_PAY_ON_DEMAND_ACCESS_OVERSTAY}_SUCCESS`:
    case `${types.CPM_PAY_ON_DEMAND_ACCESS_OVERSTAY}_ERROR`:
    case `${types.CPM_CREATE_PARTNER}_SUCCESS`:
    case `${types.CPM_CREATE_PARTNER}_ERROR`:
    case `${types.CPM_UPDATE_PARTNER_FINANCIAL_INFORMATION}_SUCCESS`:
    case `${types.CPM_UPDATE_PARTNER_FINANCIAL_INFORMATION}_ERROR`:
    case `${types.CPM_DOWNLOAD_CARPARK_INVOICE}_SUCCESS`:
    case `${types.CPM_DOWNLOAD_CARPARK_INVOICE}_ERROR`:
    case `${types.CPM_DOWNLOAD_CARPARK_INVOICES}_SUCCESS`:
    case `${types.CPM_DOWNLOAD_CARPARK_INVOICES}_ERROR`:
    case `${types.CPM_DOWNLOAD_MY_INVOICE}_SUCCESS`:
    case `${types.CPM_DOWNLOAD_MY_INVOICE}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_INVOICE}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_INVOICE}_ERROR`:
    case `${types.CPM_CREATE_ON_DEMAND_ACCESS}_SUCCESS`:
    case `${types.CPM_CREATE_ON_DEMAND_ACCESS}_ERROR`:
    case `${types.CPM_TERMINATE_ON_DEMAND_ACCESS}_SUCCESS`:
    case `${types.CPM_TERMINATE_ON_DEMAND_ACCESS}_ERROR`:
    case `${types.CPM_UPDATE_ON_DEMAND_ACCESS_CUSTOMER}_SUCCESS`:
    case `${types.CPM_UPDATE_ON_DEMAND_ACCESS_CUSTOMER}_ERROR`:
    case `${types.CPM_UPDATE_ON_DEMAND_ACCESS}_SUCCESS`:
    case `${types.CPM_UPDATE_ON_DEMAND_ACCESS}_ERROR`:
    case `${types.CPM_DECLARE_FINAL_EXIT_FOR_TEMPORARY_ON_DEMAND_ACCESS}_SUCCESS`:
    case `${types.CPM_DECLARE_FINAL_EXIT_FOR_TEMPORARY_ON_DEMAND_ACCESS}_ERROR`:
    case `${types.CPM_DECLARE_FINAL_EXIT_FOR_BOOKING}_SUCCESS`:
    case `${types.CPM_DECLARE_FINAL_EXIT_FOR_BOOKING}_ERROR`:
    case `${types.CPM_CREATE_WORKSPACE}_SUCCESS`:
    case `${types.CPM_CREATE_WORKSPACE}_ERROR`:
    case `${types.CPM_CREATE_WORKSPACE_GROUP}_SUCCESS`:
    case `${types.CPM_CREATE_WORKSPACE_GROUP}_ERROR`:
    case `${types.CPM_UPDATE_WORKSPACE}_SUCCESS`:
    case `${types.CPM_UPDATE_WORKSPACE}_ERROR`:
    case `${types.CPM_UPDATE_WORKSPACE_GROUP}_SUCCESS`:
    case `${types.CPM_UPDATE_WORKSPACE_GROUP}_ERROR`:
    case `${types.CPM_INITIATE_PAYMENT}_SUCCESS`:
    case `${types.CPM_INITIATE_PAYMENT}_ERROR`:
    case `${types.CPM_DELETE_MY_PAYMENT_METHOD}_SUCCESS`:
    case `${types.CPM_DELETE_MY_PAYMENT_METHOD}_ERROR`:
    case `${types.CPM_UPDATE_CARPARK_WORKSPACE_GROUPS}_SUCCESS`:
    case `${types.CPM_UPDATE_CARPARK_WORKSPACE_GROUPS}_ERROR`:
    case `${types.CPM_CREATE_SLUG}_SUCCESS`:
    case `${types.CPM_CREATE_SLUG}_ERROR`:
    case `${types.CPM_DELETE_SLUG}_SUCCESS`:
    case `${types.CPM_DELETE_SLUG}_ERROR`:
    case `${types.CPM_UPDATE_SLUG}_SUCCESS`:
    case `${types.CPM_UPDATE_SLUG}_ERROR`:
    case `${types.CPM_SIGN_UP}_SUCCESS`:
    case `${types.CPM_SIGN_UP}_ERROR`:
    case `${types.CPM_CREATE_SERVICE_FEE_RULE}_SUCCESS`:
    case `${types.CPM_CREATE_SERVICE_FEE_RULE}_ERROR`:
    case `${types.CPM_DELETE_SERVICE_FEE_RULE}_SUCCESS`:
    case `${types.CPM_DELETE_SERVICE_FEE_RULE}_ERROR`:
    case `${types.CPM_UPDATE_SERVICE_FEE_RULE}_SUCCESS`:
    case `${types.CPM_UPDATE_SERVICE_FEE_RULE}_ERROR`:
    case `${types.CPM_RESEND_BOOKING_CONFIRMATION_EMAIL}_SUCCESS`:
    case `${types.CPM_RESEND_BOOKING_CONFIRMATION_EMAIL}_ERROR`:
      return {
        ...state,
        operation: false,
        processing: false,
      };

    default:
      return state;
  }
};

export default loading;



// WEBPACK FOOTER //
// ./reducers/app/loading.js